import React, { Component } from 'react';
import {Form, Input, Button, message, Tabs} from 'antd'
import {fetchData} from '../../../lib/apis';
import {AccountMetaData, setCookie, dimens} from '../../../config/settings';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

const { TabPane } = Tabs;

export default class JoinCompany extends Component{
  constructor(props){
    super(props);
    this.state = {
        confirmLoading: false,
        activeTab: 'join'
    }
    this.formJoin = null;
    this.formCreate = null;
  }
  componentWillMount(){

  }
  componentWillReceiveProps(nextProps){
   
  }
  componentDidMount(){
    if(this.formCreate){
        this.formCreate.setFieldsValue({
            email: this.props.UserLogin.email,
            phone: this.props.UserLogin.phone,
        })
    }
  }
  handleSubmitJoin = async (values) => {
    try {
      this.setState({
        confirmLoading: true,
      }, () => {
        fetchData({
            url: `api/v1/company/join?code=${values.code_join}`,
            method: 'post',
            data: values
        }).then((res) => {
            setCookie(dimens.name_company, JSON.stringify(res.data), 7);
            message.success({content: 'Thao tác thành công!', duration: 3})
            this.setState({
                confirmLoading: false
            }, () => {
                if (this.formJoin) this.formJoin.resetFields();
                window.location.href = "/";
            });
        }).catch((err) => {
            this.setState({
                confirmLoading: false,
            }, () => {
                let content = err.message ? err.message : 'Đã có lỗi xảy ra vui lòng thử lại sau!';
                message.warning({ content: content, key: 'error_api', duration: 2 });
            })
        })
      });
    } catch (errorInfo) {
      console.log('Failed:', errorInfo);
    }
  };
  handleSubmitCreate = async (values) => {
    try {
      this.setState({
        confirmLoading: true,
      }, () => {
        fetchData({
            url: 'api/v1/company/create',
            method: 'post',
            data: values
        }).then((res) => {
            setCookie(dimens.name_company, JSON.stringify(res.data), 7);
            message.success({content: 'Thao tác thành công', duration: 3})
            this.setState({
                confirmLoading: false
            }, () => {
                if (this.formCreate) this.formCreate.resetFields();
                window.location.href = "/";
            });
        }).catch((err) => {
            this.setState({
                confirmLoading: false,
            }, () => {
                let content = err.message ? err.message : 'Đã có lỗi xảy ra vui lòng thử lại sau!';
                message.warning({ content: content, key: 'error_api', duration: 2 });
            })
        })
      });
    } catch (errorInfo) {
      console.log('Failed:', errorInfo);
    }
  };
  onFinishFailed = async (error) => {
    console.log(error);
  }
  render(){
    return (
        <div className="content-m">
            <div className="list-c">
              <div className="form-company">
                  <div className="logo">
                      <img src={require('../../../img/background.png')}/>
                      <h2>Bắt đầu sử dụng</h2>
                  </div>
                  <Tabs activeKey={this.state.activeTab} onChange={(key) => this.setState({activeTab: key})} centered>
                    <TabPane tab="Tạo công ty mới" key="create">
                      <Form
                          name="create"
                          onFinish={this.handleSubmitCreate}
                          onFinishFailed={this.onFinishFailed}
                          ref={(evt) => this.formCreate = evt}
                      >
                          <Form.Item
                              name="company_name"
                              rules={[{ required: true, message: 'Tên công ty không được để trống' }]}
                          >
                              <Input placeholder="Tên công ty *" />
                          </Form.Item>
                          <Form.Item
                              name="email"
                          >
                              <Input placeholder="Email" />
                          </Form.Item>
                          <Form.Item
                              name="phone"
                          >
                              <Input placeholder="Số điện thoại" />
                          </Form.Item>
                          <Form.Item
                              name="address"
                          >
                              <Input placeholder="Địa chỉ" />
                          </Form.Item>
                          <Form.Item>
                              <Button type="primary" loading={this.state.confirmLoading} htmlType="submit" block>
                              Tạo công ty
                              </Button>
                          </Form.Item>
                      </Form>
                    </TabPane>
                    <TabPane tab="Nhập mã tham gia" key="join">
                      <Form
                          name="join"
                          onFinish={this.handleSubmitJoin}
                          onFinishFailed={this.onFinishFailed}
                          ref={(evt) => this.formJoin = evt}
                      >
                          <Form.Item
                              name="code_join"
                              rules={[{ required: true, message: 'Mã tham gia không được để trống' }]}
                          >
                              <Input placeholder="Mã tham gia *" />
                          </Form.Item>
                          <Form.Item>
                              <Button type="primary" loading={this.state.confirmLoading} htmlType="submit" block>
                              Tham gia
                              </Button>
                          </Form.Item>
                      </Form>
                    </TabPane>
                  </Tabs>
              </div>
            </div>
        </div>
    )
  }
}
